import type { HelpFile } from '../../types/help'
import { LogoTestIds } from '../../../testids/LogoTestIds'

export const logoHelp: HelpFile = {
  texts: {
    [LogoTestIds.linkHome]: null,
  },
}
